module.exports = {
  'lang': 'zh-cn',
  'remove': '移除文件',
  'down': '下载文件',
  'fileLoading': '文件上传中',
  'zh-cn': {
    'remove': '移除文件',
    'down': '下载文件',
    'fileLoading': '文件上传中'
  },
  'en-us': {
    'remove': 'delete',
    'down': 'download',
    'fileLoading': 'The file on the cross'
  },
  'zh-tw': {
    'remove': '移除文件',
    'down': '下載文件',
    'fileLoading': '文件上傳中'
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/i18n.js